<template>
    <div id="resourceFile">
        <div class="recommend_wrapper">
            <h3>{{ packInfo.packName }}</h3>
            <span class="file_count">本专题所含<i>{{ packInfo.packCount }}</i>个资源</span>
            <div class="recommend_top">
                <img id="packImage" :src="!packInfo.headPicpath ? '/styles/rescover.png' : packInfo.headPicpath"/>
                <div class="recommend_product">{{ packInfo.packageDesc }}</div>
            </div>
            <div class="recommend_bottom">
                <el-table :data="rscList" border style="width: 100%" @row-click="changeUrl">
                    <el-table-column type="index" label="序号" width="156" text-align="center"/>
                    <el-table-column prop="TITLE" label="资源名称" width="618"/>
                    <el-table-column prop="RSCFILETYPE" label="资源类型"/>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
  import { recommendDetail } from '@/api/resourceDetail';

  export default {
    name: '',
    components: {},
    props: {},
    data () {
      return {
        packID: '',
        packInfo: {},
        rscList: [],
      };
    },
    created () {
      this.packID = this.$route.query.packID;
    },
    async mounted () {
      const params = {
        packID: this.packID
      };
      await recommendDetail(params).then(data => {
        const me = this;
        const { packInfo, rscList } = data.result;
        me.packInfo = packInfo;
        me.rscList = rscList;

        me.rscList.map(item => {
          switch (item.RSCFILETYPE) {
            case 1:
              item.RSCFILETYPE = '文档';
              break;
            case 2:
              item.RSCFILETYPE = '视频';
              break;
            case 4:
              item.RSCFILETYPE = '音频';
              break;
            default:
          }
        });
      });
    },
    methods: {
      changeUrl (row) {
        let rscId = row.RSCID;
        this.$router.push({
          path: '/resource/detail',
          query: {
            rscId: rscId
          }
        });
      }
    }
  };
</script>
